<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>QR Obras</h2>
    <h3>Admin - Exportar</h3>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="system-table p-h-lg">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Exportar</th>
          <th class="width5"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="title">Lista Obras</td>
          <td class="text-center">
            <div class="btn-icon btn-icon-auto btn-download">
              <button class="icon-table icon-table-text" (click)="export(1)">Download</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>